import Select from '../../../components/ui/Select';
import { signerColor } from '../lib/fieldTypes';

/** Colored recipient picker — new fields are assigned to the selected signer. */
export default function RecipientSelect({ signers, value, onChange }) {
  const options = signers.map((s) => ({
    value: s.id,
    label: `${s.firstName} ${s.lastName} · ${s.email}`,
    name: `${s.firstName} ${s.lastName}`,
    icon: (
      <span
        className="h-3 w-3 rounded-full"
        style={{ background: signerColor(s.sequence) }}
      />
    ),
  }));
  return (
    <div>
      <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">
        Placing fields for
      </label>
      <Select
        value={value}
        onChange={(v) => onChange(v)}
        options={options}
        className="w-full"
        ariaLabel="Placing fields for"
        renderValue={(opt) => (
          <>
            <span className="shrink-0">{opt.icon}</span>
            <span className="truncate">{opt.name}</span>
          </>
        )}
      />
    </div>
  );
}
